// extracted by mini-css-extract-plugin
module.exports = {"loading_fork_spoon":"Loading-module__loading_fork_spoon___3Sy0t"};